export const introduction = [
  {
    id: 'problem-awareness',
    title: 'Forse sei qui perché...',
    content: 'In questo particolare momento della tua vita, ti stai ritrovando a fare i conti con difficoltà che fino a poco tempo fa non avevi. Azioni che fanno parte del tuo quotidiano e con le quali hai molta familiarità, sono improvvisamente diventate difficili, pesanti… quasi insostenibili! È tutto molto strano perché non hai mai avuto problemi di questo tipo e quasi ti vergogni ad ammetterlo, però adesso la situazione è esattamente questa e non puoi proprio farne a meno.',
    image: 'intro-1',
    layout: 'text-image',
    cta: {
      text: 'Prenota la tua prossima consulenza',
      action: 'book-appointment'
    },
    metadata: {
      order: 1,
      section: 'introduction'
    }
  },
  {
    id: 'life-too-short',
    title: 'La vita è troppo breve per essere infelici',
    content: 'La cosa peggiore è che non ti senti più te stess*, come se non sapessi più fare tutte quelle cose che ti riuscivano così bene, nel lavoro, nel tuo gruppo di amici, con il tuo partner… è tutto sbagliato ora! Questa situazione ti sta incastrando, non si va più avanti e si rischia addirittura di tornare indietro, dopo tutta la fatica e l\'impegno che hai messo per arrivare lì dove sei ora… perché sta succedendo? E cosa fare??',
    image: 'intro-2',
    layout: 'image-text',
    metadata: {
      order: 2,
      section: 'introduction'
    }
  },
  {
    id: 'change-possible',
    title: 'Cambiare è possibile!',
    content: 'Non tutto è perduto però, la situazione non è irreversibile e cambiare è possibile! Anche solo il fatto che tu sia arrivat* qui a leggere queste parole, significa che hai preso coscienza di cosa stia andando storto; magari non hai ancora ben chiaro quali siano i motivi per i quali adesso ti trovi in questa situazione, ma di certo sai che non è quello che vuoi e hai deciso di fare qualcosa!',
    image: 'intro-3',
    layout: 'text-image',
    metadata: {
      order: 3,
      section: 'introduction'
    }
  },
  {
    id: 'imagine-different',
    title: 'Immagina qualcosa di diverso...',
    content: 'Come sarebbe la tua vita se riuscissi a sentirti di nuovo te stess*? Se potessi di nuovo prendere in mano la tua vita e decidere cosa farne, anziché essere schiav* delle difficoltà che stai affrontando ora? Di certo potresti provare di nuovo la soddisfazione di riuscire nel tuo lavoro, di essere presente per i tuoi cari e di fare ciò che più ti piace senza sentirti paralizzat*. La psicoterapia è ciò di cui hai bisogno per tornare ad essere la persona che vuoi essere, a realizzare a pieno il tuo potenziale e godere della tua vita in modo sereno. Tramite la mia formazione specifica posso insegnarti a conoscere davvero il circolo vizioso nel quale sei incastrat*, comprenderlo e soprattutto capire come si è strutturato nel tempo e perché. Il lavoro con ogni mio paziente parte proprio da qui: dal blocco che si vive nel presente e questo è vero anche per te, individueremo il blocco e capiremo come farti ripartire! Cambiare è possibile, fai un altro passo verso la persona che vuoi essere veramente prenotando il tuo primo colloquio!',
    image: 'intro-centerpiece',
    layout: 'text-only-with-center-image',
    metadata: {
      order: 4,
      section: 'introduction'
    }
  }
];